import Pagination from '@/util/pagination'
import { formatDate } from '@/util/helpers'

export default function () {
  return {
    formatDate,
    pagination: new Pagination(),
    notifications: [],
    showDeleteDialog: false,
    deletingId: null,
  }
}
